// import MobileFirstImage from '../assets/images/mobile-image1.jpg'
// import MobileSecondImage from '../assets/images/mobile-image2.jpg'
// import MobileThirdImage from '../assets/images/mobile-image3.jpg'

// import TabFirstImage from '../assets/images/tab-image1.jpg'
// import TabSecondImage from '../assets/images/tab-image2.jpg'
// import TabThirdImage from '../assets/images/tab-image3.jpg'

// import DesktopFirstImage from '../assets/images/desktop-image1.jpg'
// import DesktopSecondImage from '../assets/images/desktop-image2.jpg'
// import DesktopThirdImage from '../assets/images/desktop-image3.jpg'

import SliderFirstImage from '../assets/images/slider-biryani.jpg'
import SliderSecondImage from '../assets/images/slider-biryani1.jpg'
import SliderThirdImage from '../assets/images/biryani-background(copy).jpg'

export default {
  mobile: [
    {
      title: "",
      description: "",
      url: SliderFirstImage
    },
    {
      title: "",
      description: "",
      url: SliderSecondImage
    },
    {
      title: "",
      description: "",
      url: SliderThirdImage
    }
  ],
  tab: [
    {
      title: "",
      description: "",
      url: SliderFirstImage
    },
    {
      title: "",
      description: "",
      url: SliderSecondImage
    },
    {
      title: "",
      description: "",
      url: SliderThirdImage
    }
  ],
  desktop: [
    {
      title: "",
      description: "",
      url: SliderFirstImage
    },
    {
      title: "",
      description: "",
      url: SliderSecondImage
    },
    {
      title: "",
      description: "",
      url: SliderThirdImage
    }
  ]
}
